import { select } from 'redux-saga/effects';

export const mediaSelector = state => state.application.media.data;

export function* createMediaRequest() {
  const mediaState = yield select(mediaSelector);
  // Create the request here with all the data needed form the state, and return the JSON to call API
  return mediaState;
}
